import { render, staticRenderFns } from "./StripeElement.vue?vue&type=template&id=84f29cec"
import script from "./StripeElement.vue?vue&type=script&lang=js"
export * from "./StripeElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports